<template>
  <header class="top-0 bg-white dark:bg-darkblue-900 px-4 lg:px-10 flex-none">
    <div class="flex responsive-spacing-y space-x-2 items-center">
      <div
        v-if="!content.url"
        class="group flex-none h-11 w-11 bg-secondary-50 dark:bg-darkblue flex items-center justify-center rounded-full"
      >
        <BaseIcon :name="content.icon" class="text-secondary dark:text-darkblue-200" :ariaHidden="true"/>
      </div>
      <div
        v-else
        class="group flex-none">
        <router-link :to="{name: content.url}">
          <base-button-icon name="arrowleft" size="lg" mode="primary-phantom" ariaLabel="Volver a la vista anterior"/>
        </router-link>
      </div>
      <div class="relative w-full">
        <ul v-if="content.breadcrumb" class="breadcrumbs absolute -top-4 text-sm left-0 flex items-top space-x-2 truncate">
          <li v-for="(item, idx) in content.breadcrumb" :key="idx" class="">
              <router-link :to="{name:  item.path}">{{ item.name }}</router-link>
          </li>
        </ul>
        <h1 class="font-medium dark:text-white">{{ content.title }}</h1>
      </div>
      <div
        v-if="hasNav"
        ref="nav"
        v-outside:click="{ exclude: ['nav'], handler: closeNav }"
        class="flex-none relative ml-auto lg:hidden"
      >
      </div>
      <div 
        v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador') && !isLower1024"
        class="flex w-full"
        >
        <base-button
          mode='primary-phantom' 
          size="xs"
          :text="$t('app.apply_all')" 
          @click="applyAllFilter"
          class="mr-2 w-96"
          />
        <AccessibleElSelect
          v-model="selectedClient"
          prop="selectedClient"
          :options="dataSelectForAccessibleSelect"
          :withFormItem="false"
          :isDisabled="disableSelect"
          :clearable="false"
          @change="changeClient"
          class="w-full mr-2"
          size="small"
          id-prefix="baseheaderdashboard"
        />
      </div>
    </div>
    <div  
      v-if="(role === 'AdminDistribuidor' || role === 'SuperAdminDistribuidor' || role === 'SuperAdministrador') && isLower1024"
      class="flex mb-4">
      <base-button
        mode='primary-phantom' 
        size="xs"
        :text="$t('app.apply')" 
        @click="applyAllFilter"
        class="mr-2 w-56"
        />
        <AccessibleElSelect
          v-model="selectedClient"
          prop="selectedClient"
          :options="dataSelectForAccessibleSelect"
          :withFormItem="false"
          :isDisabled="disableSelect"
          @change="changeClient"
          class="w-full mr-2"
          size="small"
          id-prefix="baseheaderdashboard"
        />
    </div>
  </header>
</template>

<script>
// import DropDownNav from '@/components/DropDownNav.vue'
import { getClients } from '@/services/clients/getClients'
import { bus } from '@/main'
import AccessibleElSelect from '@/components/elementui/AccessibleElSelect.vue'

export default {
  name: 'base-header',
  props: {
    content: {
      type: [Array, Object],
      required: true
    },
    disableSelect: {
      type: Boolean,
      default: false
    }
  },
  components: {
    AccessibleElSelect
  //    DropDownNav
  },
  mounted () {
    if (this.role === 'AdminDistribuidor' || this.role === 'SuperAdminDistribuidor' || this.role === 'SuperAdministrador') {
      this.selectedClient = this.$store.getters['dashboard/getSelectedClient']
      // Get Clientes TODO
      this.getClients()
    }
  },
  data: function () {
    return {
      nav: false,
      dataSelect: [],
      selectedClient: -1,
      emptyClient: { value: -1, name: '-- Desactivado --' },
      allClients: { value: 0, name: 'Todos los clientes' }
    }
  },
  computed: {
    hasNav: function () {
      return this.content.nav
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    isLower1024: function () {
      return this.$store.getters['app/getIsLower1024']
    },
    dataSelectForAccessibleSelect: function () {
      return this.dataSelect.map(item => ({
        id: item.value,
        name: item.name
      }))
    }
  },
  methods: {
    applyAllFilter () {
      // Aplicar a nav y alertas
      this.$store.dispatch('app/updateDashboardFilterNav')
      // Aplicar a filtros de vistas principales
      const clienteFilter = this.$store.getters['app/idClienteFilterNav']
      if (clienteFilter) {
        const payloadFilter = {
          empresa: {
            label: 'Cliente',
            value: this.$store.getters['app/idClienteFilterNav'].Nombre
          }
        }
        const payloadFilterClient = {
          name: {
            label: 'Nombre',
            value: this.$store.getters['app/idClienteFilterNav'].Nombre
          }
        }
        this.$store.commit('notifications/setMasterFilters', payloadFilter)
        this.$store.commit('companies/setMasterFilters', payloadFilter)
        this.$store.commit('certificates/setMasterFilters', payloadFilter)
        this.$store.commit('users/setMasterFilters', payloadFilter)
        this.$store.commit('groups/setMasterFilters', payloadFilter)
        this.$store.commit('rules/setMasterFilters', payloadFilter)
        this.$store.commit('configflow/setMasterFilters', payloadFilter)
        this.$store.commit('orgprovinces/setMasterFilters', payloadFilter)
        this.$store.commit('apirequests/setMasterFilters', payloadFilter)
        this.$store.commit('documentmaster/setMasterFilters', payloadFilter)
        this.$store.commit('imports/setMasterFilters', payloadFilter)
        this.$store.commit('procedings/setMasterFilters', payloadFilter)

        this.$store.commit('trashNotifications/setMasterFilters', payloadFilter)
        this.$store.commit('trashCompanies/setMasterFilters', payloadFilter)
        this.$store.commit('trashCertificates/setMasterFilters', payloadFilter)
        this.$store.commit('trashUsers/setMasterFilters', payloadFilter)
        this.$store.commit('trashGroups/setMasterFilters', payloadFilter)

        this.$store.commit('clients/setMasterFilters', payloadFilterClient)
      } else {
        this.$store.commit('notifications/resetMasterFilters')
        this.$store.commit('companies/resetMasterFilters')
        this.$store.commit('certificates/resetMasterFilters')
        this.$store.commit('users/resetMasterFilters')
        this.$store.commit('groups/resetMasterFilters')
        this.$store.commit('rules/resetMasterFilters')
        this.$store.commit('configflow/resetMasterFilters')
        this.$store.commit('orgprovinces/resetMasterFilters')
        this.$store.commit('apirequests/resetMasterFilters')
        this.$store.commit('documentmaster/resetMasterFilters')
        this.$store.commit('imports/resetMasterFilters')
        this.$store.commit('procedings/resetMasterFilters')

        this.$store.commit('trashNotifications/resetMasterFilters')
        this.$store.commit('trashCompanies/resetMasterFilters')
        this.$store.commit('trashCertificates/resetMasterFilters')
        this.$store.commit('trashUsers/resetMasterFilters')
        this.$store.commit('trashGroups/resetMasterFilters')
        
        this.$store.commit('clients/resetMasterFilters')
      }
      // Refresca nav y alertas
      bus.$emit('changeIt', 'changed menu')
      this.$store.dispatch('app/getAnnouncementsList')

      this.doFeedback('Filtro aplicado a todas las vistas correctamente', 'success')
    },
    getClients: async function () {
      const dataClients = await getClients()
      if (dataClients.blnError === true) {
        this.doFeedback(dataClients.msgError + ' [Código de error: ' + dataClients.codError + ']')
      } else {
        this.dataSelect = []
        this.dataSelect.push(this.emptyClient)

        // if (this.role !== 'AdminDistribuidor' && this.role !== 'SuperAdminDistribuidor') {
        //   this.dataSelect.push(this.allClients)
        // }
        this.dataSelect.push(this.allClients)

        dataClients.Empresas.forEach(element => {
          this.dataSelect.push({ value: element.IdEmpresa, name: this.truncate(element.Nombre, 50, false), nombreCompleto: element.Nombre })
        })
        this.dataSelect.sort((a, b) => {
          return a.Nombre - b.Nombre
        })
      }
    },
    toggleNav: function () {
      this.nav = !this.nav
    },
    closeNav: function () {
      this.nav = false
    },
    changeClient (idClient) {
      this.selectedClient = idClient
      this.$store.dispatch('dashboard/setSelectedClient', idClient)
      const clientName = this.dataSelect.filter(x => x.value === idClient)[0].nombreCompleto
      this.$store.dispatch('dashboard/setSelectedClientName', clientName)
      this.$emit('onChangeClient')
    }
  }
}
</script>
<style lang="scss" scoped>
.breadcrumbs {
  li {
    @apply text-secondary dark:text-white font-bold;
    &:not(:last-child) {
      @apply text-secondary-500 dark:text-white font-normal;
      &:after {
        content:'→';
        margin-left:0.25rem;
      }
    }
  }
}
</style>
